<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1><span>{{title}}</span></h1>
    </v-layout>
    <div>
      <h3>Аттестация</h3>
      <data-table :headers="headers" :items="attestationItems">
        <tr slot-scope="props" class="text-xs-center">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.test }} из 50</td>
          <td>{{ props.item.thematic}} из 30</td>
          <td>{{ props.item.practice }} из 40</td>
          <td>{{ total(props.item) }} из 120</td>
          <td>{{ props.item.status }}</td>
          <td>
            <v-btn flat icon
                   :to="{name: 'AdminAttestationInfoStudentResult', params: {id: props.item.id.toString()}}">
              <v-icon small>visibility</v-icon>
            </v-btn>
          </td>
        </tr>
      </data-table>
    </div>
    <div>
      <h3>Тренировки</h3>
      <data-table :headers="headers" :items="trainingItems">
        <tr slot-scope="props" class="text-xs-center">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.test }} из 50</td>
          <td>{{ props.item.thematic}} из 30</td>
          <td>{{ props.item.practice }} из 40</td>
          <td>{{ total(props.item) }} из 120</td>
          <td>{{ props.item.status }}</td>
          <td>
            <v-btn flat icon
                   :to="{name: 'AdminAttestationInfoStudentResult', params: {id: props.item.id.toString()}}">
              <v-icon small>visibility</v-icon>
            </v-btn>
          </td>
        </tr>
      </data-table>
    </div>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import DataTable from '@/components/fragments/DataTable'
import AttestationService from '@/services/AttestationService'

export default {
  props: {
    id: String
  },
  components: {DataTable},
  data: () => ({
    title: 'Результаты аттестуемого',
    isTraining: false,
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'Тестирование', align: 'center', sortable: false},
      {text: 'Тематические', align: 'center', sortable: false},
      {text: 'Практические', align: 'center', sortable: false},
      {text: 'Итого', align: 'center', sortable: false},
      {text: 'Результат', align: 'center', sortable: false},
      {text: 'Действия', align: 'center', sortable: false, width: 156}
    ],
    trainingItems: [],
    attestationItems: [],
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {
    total (item) {
      return item.test + item.thematic + item.practice
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.getTrainingStudentResults(this.id, (data) => {
      if (data.results) {
        this.trainingItems = data.results
      }
    })
    this.attestationService.getAttestationResults(this.id, (data) => {
      if (data.results) {
        this.attestationItems = data.results
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/attesation_info/student/Index.vue